import { fromPairs, last, first, parseJson } from "@welshman/lib";
import { getAddress } from "./Address.js";
import { getAddressTags, getKindTagValues } from "./Tags.js";
export const readHandlers = (event) => {
    const { d: identifier } = fromPairs(event.tags);
    const meta = parseJson(event.content);
    const normalizedMeta = {
        name: meta?.name || meta?.display_name || "",
        image: meta?.image || meta?.picture || "",
        about: meta?.about || "",
        website: meta?.website || "",
        lud16: meta?.lud16 || "",
        nip05: meta?.nip05 || "",
    };
    // If our meta is missing important stuff, don't bother showing it
    if (!normalizedMeta.name || !normalizedMeta.image) {
        return [];
    }
    return getKindTagValues(event.tags).map(kind => ({
        ...normalizedMeta,
        kind,
        identifier,
        event,
    }));
};
export const getHandlerKey = (handler) => `${handler.kind}:${getAddress(handler.event)}`;
export const displayHandler = (handler, fallback = "") => handler?.name || fallback;
export const getHandlerAddress = (event) => {
    const tags = getAddressTags(event.tags);
    const tag = tags.find(t => last(t) === "web") || first(tags);
    return tag?.[1];
};
//# sourceMappingURL=Handler.js.map